import React from 'react';
import PropTypes from 'prop-types';

function ElevatedCard({ children, className }) {
  return (
    <section className={`component_elevated-card ${className}`}>
      {children}
    </section>
  );
}

ElevatedCard.defaultProps = {
  className: '',
};

ElevatedCard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

export default ElevatedCard;
